import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa"; // For Hamburger menu icons

const Navbar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false); // State to manage mobile menu open/close

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-green-600 text-white py-4 shadow-md fixed top-0 left-0 right-0 z-50 overflow-x-hidden w-screen">
      <div className="container mx-auto flex justify-between items-center px-4">
        {/* Brand Name */}
        <div>
          <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold">υγεία</h1>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-6">
          <a href="#service" className="hover:underline">
            Services
          </a>
          <a href="#about" className="hover:underline">
            About Us
          </a>
          <a href="#contact" className="hover:underline">
            Contact Us
          </a>
        </div>

        {/* Login Button */}
        <div className="hidden md:block">
          <p
            className="cursor-pointer bg-white text-green-600 py-2 px-4 rounded-lg transition-colors duration-300 hover:bg-green-500 hover:text-white"
            onClick={() => navigate("/auth/select-user-type")}
          >
            Login
          </p>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center">
          <button onClick={toggleMenu} aria-label="Toggle Menu">
            {isOpen ? (
              <FaTimes className="text-2xl" /> // Close icon when open
            ) : (
              <FaBars className="text-2xl" /> // Hamburger icon when closed
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-green-600 py-6 flex flex-col items-center space-y-4 rounded-b-lg shadow-lg">
          <a
            href="#service"
            onClick={toggleMenu}
            className="hover:underline text-lg"
          >
            Services
          </a>
          <a
            href="#about"
            onClick={toggleMenu}
            className="hover:underline text-lg"
          >
            About Us
          </a>
          <a
            href="#contact"
            onClick={toggleMenu}
            className="hover:underline text-lg"
          >
            Contact Us
          </a>
          <p
            className="cursor-pointer bg-white text-green-600 py-2 px-6 rounded-lg transition-colors duration-300 hover:bg-green-500 hover:text-white"
            onClick={() => {
              navigate("/auth/select-user-type");
              toggleMenu(); // Close the menu after navigating
            }}
          >
            Login
          </p>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
